export const getPortalTarget = (
  id: string | null,
  targetDocument?: Document | null,
): HTMLElement => {
  const doc = targetDocument || document;
  const targetElement = id ? doc.getElementById(id) : null;
  return targetElement || doc.body;
};
